import { Box, Container, Typography } from '@mui/material';
import { HospitalManagement } from 'components/templates';
import React from 'react';

export const HospitalsAndClinics = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'left' }}>
          Hospitals and Clinics
        </Typography>
      </Box>
      <HospitalManagement />
    </Container>
  );
};
